const caseStudies = [
  {
    id: 1,
    name: "HK Mobile: Real-Time Heroku Visibility, Built for Mobile",
    homeTag: "Mobile Cloud Visibility",
    homeTitle: "HK Mobile Heroku Dashboard",
    subheading:
      "A native mobile application giving cloud platform users on-the-go access to billing intelligence, usage analytics, and contract alignment.",
    client: "Enterprise Technology Client",
    status: "Live - Active Rebrand in Progress",
    image:
      "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,c_limit,w_900,h_700/v1722338670/werkix/clients/header-slide-1_1_qa6uxv.png",
    summary:
      "A native mobile application giving cloud platform users on-the-go access to billing intelligence, usage analytics, and contract alignment.",
    challenge:
      "An enterprise technology client needed to extend cloud platform visibility beyond the desktop. Users managing infrastructure on the move were constrained by desktop-only dashboards, leading to delayed decisions, missed billing anomalies, and poor alignment between actual usage and contracted terms.",
    solution:
      "Werkix designed and built a native mobile application from the ground up, integrating directly with the client's cloud platform. The app delivers one-tap access to app, team, and space management; graphical billing and usage views; real-time contract alignment; and configurable monitoring with live build and release tracking.",
    results:
      "3,400+ combined lifetime downloads across Google Play and the App Store. Real-time monitoring of builds, releases, and infrastructure changes. Strategic rebrand currently underway to accelerate adoption.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 2,
    name: "AI Agent Platform: Intelligent Automation for Enterprise Cloud Operations",
    homeTag: "AI Automation Platform",
    homeTitle: "Enterprise AI Agent Platform",
    subheading:
      "A production-grade AI platform deploying custom intelligent agents to deliver contextual cloud platform knowledge and automated workflows.",
    client: "Enterprise Technology Client",
    status: "Live in Production",
    image:
      "https://res.cloudinary.com/dhbe6wtod/image/upload/v1773742820/werkix/clients/logo-transparent_nrzfxt.webp",
    summary:
      "A production-grade AI platform deploying custom intelligent agents to deliver contextual cloud platform knowledge and automated workflows.",
    challenge:
      "An enterprise technology client's customers needed faster, more intelligent access to cloud platform knowledge. Traditional documentation and manual support workflows created bottlenecks, forcing teams to context-switch and wait for human intervention on routine inquiries.",
    solution:
      "Werkix designed and deployed a fully custom AI platform with modular, purpose-built agents that are continuously trained and refined. A dedicated cloud platform agent is being integrated to deliver domain expertise directly within the interface, and the system supports a daily deployment cadence pushing enhancements into production.",
    results:
      "Live in production and actively serving enterprise users. Multiple custom AI agents developed and in active demonstrations. Daily deployment cadence ensuring continuous improvement.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 3,
    name: "Enterprise Customer Portal: Performance, Stability, and Advanced Analytics at Scale",
    homeTag: "Portal Performance at Scale",
    homeTitle: "Enterprise Customer Portal",
    subheading:
      "A high-traffic customer portal serving tens of thousands of users, modernized for stability and enriched with advanced third-party analytics integration.",
    client: "Enterprise Technology Client",
    status: "Live in Production",
    image:
      "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=1600&q=80",
    summary:
      "A high-traffic customer portal serving tens of thousands of users, modernized for stability and enriched with advanced third-party analytics integration.",
    challenge:
      "An enterprise client needed a trusted partner to take ownership of a high-traffic customer portal serving over 21,000 registered users. Legacy performance issues were threatening platform stability, and the business required deep integration with a third-party analytics provider to deliver advanced reporting.",
    solution:
      "Werkix took ownership of the platform architecture and ongoing development, executing comprehensive performance optimization that resolved root-cause reliability issues. The team completed a full third-party analytics integration to surface advanced reporting within the customer experience.",
    results:
      "21,746 registered users with approximately 90 daily active users. All previously identified performance issues fully resolved. Advanced analytics integration completed and ready for activation.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 4,
    name: "Heroku MSP Dashboard: Enterprise Monitoring, Change Detection, and Billing Intelligence",
    homeTag: "MSP Monitoring & Billing",
    homeTitle: "Heroku MSP Dashboard",
    subheading:
      "A multi-tenant, enterprise-grade monitoring platform providing continuous visibility into cloud environments with infrastructure change detection, usage tracking, and auditable insights.",
    client: "Enterprise Technology Client",
    status: "Live in Production",
    image:
      "https://res.cloudinary.com/dhbe6wtod/image/upload/v1773742822/werkix/clients/msp_eot1bo.png",
    summary:
      "A multi-tenant, enterprise-grade monitoring platform providing continuous visibility into cloud environments with infrastructure change detection, usage tracking, and auditable insights.",
    challenge:
      "Organizations running enterprise cloud infrastructure had no centralized way to audit infrastructure or configuration changes, or to securely track license and resource usage over time. The result was elevated operational risk, poor cost control, and slower incident response.",
    solution:
      "Werkix built a multi-tenant monitoring dashboard to continuously observe customer environments, establishing a historical source of truth. The platform detects infrastructure and access changes, tracks resource and license usage for billing accountability, and delivers actionable insights through secure dashboards and APIs.",
    results:
      "Continuous, real-time visibility across enterprise cloud environments. Granular billing and license accountability through usage tracking. Secure multi-tenant architecture with full data isolation.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 5,
    name: "Salesforce Compliance Managed Package: Real-Time Outreach Validation",
    homeTag: "Salesforce Compliance",
    homeTitle: "Real-Time Outreach Validation",
    subheading:
      "A managed Salesforce package embedding live regulatory compliance checks directly into sales workflows, eliminating manual verification at scale.",
    client: "Enterprise Technology Client",
    status: "Completed",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg",
    summary:
      "A managed Salesforce package embedding live regulatory compliance checks directly into sales workflows, eliminating manual verification at scale.",
    challenge:
      "An enterprise client engaged Werkix to build a managed Salesforce package embedding real-time regulatory compliance checks directly into sales workflows. Manual validation against external compliance registries was slow, error-prone, and difficult to enforce consistently across orgs with custom data models.",
    solution:
      "Werkix delivered a managed package with a split managed/unmanaged architecture to overcome Salesforce cross-namespace limitations. It features dynamic field discovery for standard and custom phone and email fields, a cloud adapter for live compliance validation, a built-in phone dialer with full call lifecycle management, and visual compliance indicators across core objects.",
    results:
      "Released to production with standard Salesforce install and zero custom deployment. Plug-and-play compliance coverage across subscriber orgs. Full call lifecycle management with automatic activity logging.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 6,
    name: "Salesforce Health Cloud Platform: Unified Patient Data and Automated Care Coordination",
    homeTag: "Health Cloud Integration",
    homeTitle: "Unified Patient Care Platform",
    subheading:
      "A Salesforce Health Cloud implementation consolidating fragmented clinical data into a single longitudinal patient view, with automated care coordination at scale.",
    client: "Enterprise Technology Client",
    status: "In Active Development",
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1600&q=80",
    summary:
      "A Salesforce Health Cloud implementation consolidating fragmented clinical data into a single longitudinal patient view, with automated care coordination at scale.",
    challenge:
      "An enterprise client engaged Werkix to deliver a centralized Salesforce Health Cloud platform for managing patient populations with chronic conditions. Care teams were working across fragmented clinical data from multiple external EHR systems, making it difficult to consistently enroll patients, assign providers, and manage care plans at scale.",
    solution:
      "Werkix engineered automated CCD and ADT integrations to ingest clinical data from external EHR systems directly into Salesforce Health Cloud. Salesforce Flows drive automated patient enrollment into disease-specific care programs, assign care team members based on imported clinical documents, and create diagnosis-driven care plans across the provider network.",
    results:
      "Unified, longitudinal patient view consolidating data from multiple EHR sources. Automated enrollment and care team assignment for chronic disease programs. Architecture designed to scale across additional disease management programs.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 7,
    name: "Multi-Service Operations CRM: Centralized Sales, Quoting, and Vendor Coordination",
    homeTag: "Operations CRM",
    homeTitle: "Multi-Service Sales & Quoting",
    subheading:
      "A Salesforce CRM unifying complex multi-service sales workflows, vendor fulfillment, and field operations across nationwide service delivery.",
    client: "Enterprise Technology Client",
    status: "In Active Development",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80",
    summary:
      "A Salesforce CRM unifying complex multi-service sales workflows, vendor fulfillment, and field operations across nationwide service delivery.",
    challenge:
      "An enterprise client engaged Werkix to implement a Salesforce CRM for managing complex, multi-service customer engagements across a broad portfolio of field service offerings. Existing workflows were fragmented and difficult to scale across nationwide operations.",
    solution:
      "Werkix implemented Salesforce CRM to manage the full sales lifecycle, from account creation with duplicate detection through multi-service opportunity and quote management. Guided workflows support location-based quoting, vendor partner assignment, and automatic follow-up scheduling. The platform integrates with a cloud PostgreSQL database to synchronize vendor data and support ongoing service fulfillment.",
    results:
      "Unified platform for customer relationships across nationwide operations. Structured workflows for multi-service quoting and vendor coordination. Cloud database integration connecting sales workflows to fulfillment.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
  {
    id: 8,
    name: "ConnectSecure: Enterprise Vulnerability Management Across 130+ Endpoints",
    homeTag: "How Enhancing IT Support",
    homeTitle: "A Case Study Of ConnectSecure At Rojoli Services",
    subheading:
      "A full ConnectSecure deployment delivering continuous vulnerability scanning, proactive risk detection, and centralized security oversight with zero disruption.",
    client: "Rojoli Services",
    status: "Completed - Ongoing Managed Monitoring",
    image:
      "https://res.cloudinary.com/dhbe6wtod/image/upload/v1773047554/werkix/team/41d233aa28f5b61958e8c16bf22830f4_vdj4ld.jpg",
    summary:
      "A full ConnectSecure deployment delivering continuous vulnerability scanning, proactive risk detection, and centralized security oversight with zero disruption.",
    challenge:
      "A major client required improved visibility over 130 endpoints and critical servers. Without centralized vulnerability management, there was no systematic way to detect software vulnerabilities, missing patches, or system misconfigurations before they could be exploited.",
    solution:
      "Werkix executed a staged ConnectSecure deployment across 130 endpoints, with critical servers onboarded individually to avoid disruption. The platform provides continuous scanning for vulnerabilities, missing patches, and outdated applications. Werkix's team performs daily monitoring, prioritizing high-risk issues and assisting with remediation planning.",
    results:
      "Complete visibility across 130 endpoints and critical servers. Zero-disruption staged deployment protecting business continuity. Continuous daily monitoring by Werkix's managed IT team.",
    socialLinks: {
      x: "https://www.twitter.com",
      meta: "https://www.facebook.com",
      pinterest: "https://www",
    },
  },
];

export default caseStudies;
